 $(document).ready(function(){
  $.ajax({
		url: "https://dashboard.restaurantequipment.com.au/api/collection/REO-NZ/"+collection_handle, 
		type: "GET",
		dataType: "json",
		contentType: "application/json;",
		success: function (data) {
			if(data.success == true){
				$('#show_sub_categories').html(data.html);
				//$('#show_sub_categories_mobile').html(data.html);
              $('body').find('.kg-list-content').slick({
              dots: false,
              infinite: true,
              slidesToShow: 8,
              slidesToScroll: 8,
              prevArrow: '<div class="previous"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M15.293 3.293 6.586 12l8.707 8.707 1.414-1.414L9.414 12l7.293-7.293-1.414-1.414z"/></svg></div>',
              nextArrow: '<div class="next"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M7.293 4.707 14.586 12l-7.293 7.293 1.414 1.414L17.414 12 8.707 3.293 7.293 4.707z"/></svg></div>',
              responsive: [
                {
                  breakpoint: 1440,
                  settings: {
                    slidesToShow: 6,
                    slidesToScroll: 6,
                  }
                },
                {
                  breakpoint: 1300,
                  settings: {
                    slidesToShow: 5,
                    slidesToScroll: 5,
                  }
                },
                {
                  breakpoint: 1150,
                  settings: {
                    slidesToShow: 4,
                    slidesToScroll: 4,
                  }
                },
                {
                  breakpoint: 1000,
                  settings: {
                    slidesToShow: 5,
                    slidesToScroll: 5,
                  }
                },
                {
                  breakpoint: 900,
                  settings: {
                    slidesToShow: 4,
                    slidesToScroll: 4,
                  }
                },
                {
                  breakpoint: 768,
                  settings: {
                    slidesToShow: 4,
                    slidesToScroll: 4,
                  }
                },
                {
                  breakpoint: 530,
                  settings: {
                    slidesToShow: 3,
                    slidesToScroll: 3
                  }
                },

              ]
            });
			}
		},
		error: function (err) {
			// check the err for error details
		}
	});
    })

